import io from "socket.io-client";

import { NOTIFICATIONS_SOCKET_URL } from "../../constants/api/api.constants";
import { TOKEN } from "../../constants/localStorage/localStorage.constants";
import { getItem } from "../../utils";

// Env-driven so dev/staging point at their own socket host
// (e.g. https://api.notifications.dev.truckfix.net).
const NOTIFICATION_SOCKET_URL =
  NOTIFICATIONS_SOCKET_URL || "https://api.notifications.truckfix.net";

export function initializeSocket(token) {
  if (!token) {
    console.error("Token is missing. Cannot initialize socket.");
    return null;
  }

  return io(NOTIFICATION_SOCKET_URL, {
    // Resolve the token on every connection/reconnection so a refreshed access
    // token is used instead of the value captured when the socket was created.
    auth: callback => callback({ token: getItem(TOKEN) || token }),
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000
  });
}
